import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { decryptData } from '../core/utilities';
import { BaseComponents } from '../base.component';
import bkiConfig from 'src/app/core/data/bkiConfiguration.json'
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';

@Injectable()
export class CheckblacklistValidateBKIService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService
  ) { 
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if (this.VERIFY_TOKEN_EXPIRE) {
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    if (param.bki.sub_type && param.bki.plan_name) {
      let sub_type = param.bki.sub_type;
      let plan_name = param.bki.plan_name;
      param.bki.bean["prod_type"] = bkiConfig[sub_type]["prod_type"];
      param.bki.bean["patn_plan"] = bkiConfig[sub_type]["patn_plan"] + plan_name.replace(/[^0-9\.]+/g, "");
    }
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any, ref: any = '') {
    const url = `${environment.endpointBackend}/api/services/protection/checkblacklistValidateBKI?ref=${ref}`;
    // Token lets the server keep the BKI outcome for this reference (notify reads it from there).
    const body = withBuyonlineAccessToken(ref, this.input(param));
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  exec(param: any, ref: any) {
    const self = this;
    return new Promise(function (resolve, reject) {
      if (!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()) {
        self.connector(param, ref).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            let data = res['body']['data'];
            try {
              data = decryptData(data);
              data = JSON.parse(data);
            } catch (error) {
              data = {};
            }
            self.logger.debug('checkblacklistValidateBKI=>', data);
            resolve(self.output(data));
          },
          err => {
            self.logger.debug('checkblacklistValidateBKI>error', err);
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus: 401,
          message: 'token is expired'
        });
      }
    });
  }
}
